<app-excel-review-modal
  [title]="'compliance.library.reviewExcelModal.title' | transloco"
  [subtitle]="'compliance.library.reviewExcelModal.subtitle' | transloco"
  [items]="items"
  [(selected)]="selected"
  [isLoading]="isLoading"
  [isImporting]="isImporting"
  [canImport]="canImport"
  [importLabel]="'compliance.library.reviewExcelModal.importLabel' | transloco"
  [serverErrors]="serverErrors"
  [searchPlaceholder]="'compliance.library.reviewExcelModal.searchPlaceholder' | transloco"
  [matchesSearch]="matchesSearch"
  [showAccountFilter]="true"
  [accountFilter]="accountFilter"
  [accountFilterPlaceholder]="'compliance.library.reviewExcelModal.accountFilterPlaceholder' | transloco"
  (accountFilterChanged)="onAccountFilterChange($event)"
  [entityLabel]="'compliance.library.reviewExcelModal.entityLabel' | transloco"
  [itemName]="itemName"
  [deleteWarningMessage]="'compliance.library.reviewExcelModal.deleteWarning' | transloco"
  [headerTemplate]="headerTemplate"
  [rowTemplate]="rowTemplate"
  [detailTemplate]="detailTemplate"
  [columnCount]="5 + categoryIndexes.length * 2"
  [emptyText]="'compliance.library.reviewExcelModal.emptyText' | transloco"
  [detailEmptyText]="'compliance.library.reviewExcelModal.detailEmptyText' | transloco"
  (itemRemoved)="onItemRemoved()"
  (importRequested)="importAsync()"
  (closeRequested)="close()">
</app-excel-review-modal>

<ng-template #headerTemplate>
  <th>{{ 'compliance.library.reviewExcelModal.columns.complianceName' | transloco }}</th>
  <th>{{ 'compliance.library.reviewExcelModal.columns.regions' | transloco }}</th>
  <th>{{ 'compliance.library.reviewExcelModal.columns.periodicRoutine' | transloco }}</th>
  <th>{{ 'compliance.library.reviewExcelModal.columns.frequency' | transloco }}</th>
  <th>{{ 'compliance.library.reviewExcelModal.columns.routineType' | transloco }}</th>
  @for(index of categoryIndexes; track index) {
    <th>{{ 'compliance.library.reviewExcelModal.columns.categoryNameIndexed' | transloco: { index: index + 1 } }}</th>
    <th>{{ 'compliance.library.reviewExcelModal.columns.requirementsIndexed' | transloco: { index: index + 1 } }}</th>
  }
</ng-template>

<ng-template #rowTemplate let-item>
  <td><strong>{{ item.name || '-' }}</strong></td>
  <td>
    @if(item.regionNames.length > 0) {
      <div class="region-cell">
        <span>{{ item.regionNames[0] }}</span>
        @if(item.regionNames.length > 1) {
          <ng-template #regionsTooltip>
            <strong>{{ 'compliance.library.reviewExcelModal.regionCount' | transloco: { count: item.regionNames.length } }}</strong>
            <ul>
              @for(regionName of item.regionNames; track regionName) {
                <li>{{ regionName }}</li>
              }
            </ul>
          </ng-template>
          <span class="region-cell__more" [ngbTooltip]="regionsTooltip" tooltipClass="regions-tooltip" container="body" placement="end top bottom">
            {{ 'compliance.library.reviewExcelModal.moreCount' | transloco: { count: item.regionNames.length - 1 } }}
            <i class="ph ph-info"></i>
          </span>
        }
      </div>
    } @else {
      <span>-</span>
    }
  </td>
  <td>{{ displayType(item) }}</td>
  <td>{{ displayFrequency(item) }}</td>
  <td>{{ displayRoutineType(item) }}</td>
  @for(index of categoryIndexes; track index) {
    <td>{{ item.categories[index]?.name || '-' }}</td>
    <td>{{ item.categories[index] ? ('compliance.library.reviewExcelModal.requirementsCount' | transloco: { count: item.categories[index].requirements.length }) : '-' }}</td>
  }
</ng-template>

<ng-template #detailTemplate let-selected>
  <div class="field-group">
    <label class="field-label">{{ 'compliance.library.reviewExcelModal.complianceNameLabel' | transloco }}<span class="required">*</span></label>
    <input class="field-input" type="text" [ngModel]="selected.name" (ngModelChange)="onSelectedNameChanged($event)">
  </div>

  <div class="field-group">
    <label class="field-label">{{ 'compliance.library.reviewExcelModal.regionsLabel' | transloco }}</label>
    <div ngbDropdown [autoClose]="'outside'" class="field-dropdown">
      <button type="button" ngbDropdownToggle class="field-dropdown__toggle"
        [class.field-dropdown__toggle--placeholder]="selected.regionNames.length === 0">
        @if(selected.regionNames.length > 0) {
          <span class="field-dropdown__count-badge">{{ selected.regionNames.length }}</span>
        }
        <span class="toggle-label">{{ selected.regionNames.length > 0 ? selected.regionNames[0] : ('compliance.library.reviewExcelModal.selectRegions' | transloco) }}</span>
        <i class="ph ph-caret-down lh-base"></i>
      </button>
      <div ngbDropdownMenu>
        <div class="dropdown-scroll">
          @for(regionName of unknownRegionNames(selected); track regionName) {
            <button type="button" class="btn btn-outline option option--invalid" ngbDropdownItem (click)="toggleRegion(regionName); $event.stopPropagation()">
              <input type="checkbox" class="form-check-input" [checked]="true">
              <span>{{ 'compliance.library.reviewExcelModal.unknownRegion' | transloco: { name: regionName } }}</span>
            </button>
          }
          @for(region of regions; track region.type + '-' + region.id) {
            <button type="button" class="btn btn-outline option" ngbDropdownItem (click)="toggleRegion(region.name); $event.stopPropagation()">
              <input type="checkbox" class="form-check-input" [checked]="isRegionSelected(selected, region.name)">
              <span>{{ region.name }}</span>
            </button>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="field-group">
    <label class="field-label">{{ 'compliance.library.reviewExcelModal.periodicOrRoutine' | transloco }}</label>
    <div ngbDropdown class="field-dropdown">
      <button type="button" ngbDropdownToggle class="field-dropdown__toggle"
        [class.field-dropdown__toggle--placeholder]="!hasValidType(selected)"
        [class.field-dropdown__toggle--warning]="!hasValidType(selected)">
        <span class="toggle-label">{{ hasValidType(selected) ? (isPeriodic(selected) ? ('compliance.library.complianceTypes.periodic' | transloco) : ('compliance.library.complianceTypes.routine' | transloco)) : ('compliance.library.reviewExcelModal.selectComplianceType' | transloco) }}</span>
        <i class="ph ph-caret-down lh-base"></i>
      </button>
      <div ngbDropdownMenu>
        <div class="dropdown-scroll">
          <button type="button" class="btn btn-outline option" ngbDropdownItem (click)="selectComplianceType('Periodic')">{{ 'compliance.library.complianceTypes.periodic' | transloco }}</button>
          <button type="button" class="btn btn-outline option" ngbDropdownItem (click)="selectComplianceType('Routine')">{{ 'compliance.library.complianceTypes.routine' | transloco }}</button>
        </div>
      </div>
    </div>
  </div>

  @if(hasValidType(selected)) {
    <div class="field-group">
      <label class="field-label">{{ isPeriodic(selected) ? ('compliance.library.reviewExcelModal.columns.frequency' | transloco) : ('compliance.library.reviewExcelModal.columns.routineType' | transloco) }}</label>
      <div ngbDropdown class="field-dropdown">
        <button type="button" ngbDropdownToggle class="field-dropdown__toggle"
          [class.field-dropdown__toggle--placeholder]="!selected.scheduleName"
          [class.field-dropdown__toggle--warning]="selected.errors.length > 0 && !selected.scheduleName">
          <span class="toggle-label">{{ displayScheduleName(selected) || (isPeriodic(selected) ? ('compliance.library.reviewExcelModal.selectFrequency' | transloco) : ('compliance.library.reviewExcelModal.selectRoutineType' | transloco)) }}</span>
          <i class="ph ph-caret-down lh-base"></i>
        </button>
        <div ngbDropdownMenu>
          <div class="dropdown-scroll">
            @if(isPeriodic(selected)) {
              @for(frequency of frequencies; track frequency.id) {
                <button type="button" class="btn btn-outline option" ngbDropdownItem (click)="selectSchedule(frequency.name)">{{ frequency.name | lookupLabel:'compliance.shared.frequencies' }}</button>
              }
            } @else {
              @for(routineType of routineTypes; track routineType.id) {
                <button type="button" class="btn btn-outline option" ngbDropdownItem (click)="selectSchedule(routineType.name)">{{ routineType.localizedName || routineType.name }}</button>
              }
            }
          </div>
        </div>
      </div>
    </div>
  }

  <div class="callout callout--info">
    <i class="ph-fill ph-info"></i>
    <div>
      <strong>{{ 'compliance.library.reviewExcelModal.calloutTitle' | transloco }}</strong>
      <div>{{ 'compliance.library.reviewExcelModal.calloutBody' | transloco }}</div>
    </div>
  </div>
</ng-template>